// extracted by mini-css-extract-plugin
export default {"wrapper":"p3kR0","container":"Zn3Jm","title":"EjbID","description":"YiDj_"};